import React from 'react';
import styles from './Performance.module.css';

interface TRTSComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
}

const TRTS: TRTSComponent = () => {
  return (
    <div>
      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Metric Description</div>
        <p>
          These are the most popular items that are purchased on acehardware.com that are fulfilled out of the RSC inventory rather than your store&apos;s inventory.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Supporting Details</div>
        <p>
          Find more information here:{' '}
          <a 
            href="https://acenet.aceservices.com/marketing/digital-marketing/acehardwarecom" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://acenet.aceservices.com/marketing/digital-marketing/acehardwarecom
          </a>
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Goal</div>
        <p>
          Review this document monthly to see what items are most popular to your customers and you don&apos;t carry in your store.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Update Cadence</div>
        <p>
          Metric is current state and updated monthly.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Learn More</div>
        <p>
          Review this spreadsheet to ensure you have the items your customers want, stocked in your assortment.
        </p>
        <br/>
        <p>
          For additional guidance review the Ace Way of Retailing acehardware.com fulfillment{' '}
          <a 
            href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Store Procedures
          </a>
        </p>
      </div>
    </div>
  );
};

TRTS.title = 'Most RSC Transferred SKUs';
TRTS.kpiHyperlink = 'dynamicURL:WFC:description';

export default TRTS;